module.exports = __webpack_public_path__ + "static/images/policy.0ef637c4d7b6f1c9c64eeb544563946b.svg";